import moment from "moment";

export interface IDateFormat {
  dateFormat?: any;
}

class DateFormat implements IDateFormat {
  public dateFormat?: any;
  public offset?: any;

  constructor(dateFormat?: any) {
    var today = new Date();
    var formatted_date = today.toLocaleDateString();

    var m = moment(
      formatted_date,
      ["MM/DD/YYYY", "DD/MM/YYYY", "YYYY/MM/DD"],
      true
    );
    var f = m.creationData().format;
    this.dateFormat = `${f} hh:mm A`;

    let dateObject;
    let dateFormats;
    let timeFormat = "";
    if (
      localStorage.getItem("dateObject") &&
      JSON.parse(localStorage.getItem("dateObject")).dateFormat
    ) {
      dateObject = localStorage.getItem("dateObject");
      dateFormats = JSON.parse(dateObject).dateFormat?.toUpperCase();
      if (
        JSON.parse(dateObject).timeFormat.includes("tt") ||
        JSON.parse(dateObject).timeFormat.includes("A")
      ) {
        timeFormat = "hh:mm A";
      } else {
        timeFormat = "HH:mm";
      }
      this.dateFormat = `${dateFormats} ${timeFormat}` || 'YYYY-MM-DD HH:mm a';
      this.offset = JSON.parse(dateObject).timeOffset || 330;
    }
  }

  public getDateTimeFormat(date: any): string | null {
    return date ? moment.utc(date).format(this.dateFormat) : null;
  }

  public getDateTimeRegion(): string {
    return this.dateFormat;
  }
  
  public getDateTimeRegionOffset(): string {
    return this.offset;
  }

  public getDateFormat():string{
    return JSON.parse(localStorage.getItem("dateObject")).dateFormat?.toUpperCase() || 'DD/MM/YYYY'
  }
}

const DateFormatting = new DateFormat();
export default DateFormatting;
